<template>
  <div class="reports__data mt-8">
    <v-data-table
      class="data__table"
      ref="table"
      :headers="headers"
      :items="data"
      fixed-header
      hide-default-footer
      disable-pagination
      must-sort
      :mobile-breakpoint="mobileBreakpoint"
    >
    <template v-slot:item.holiday_date="{ item }">
        <span>{{ formatDate(item.holiday_date) }}</span>
    </template>
    <template v-slot:item.discount_percentage="{ item }">
        <span>{{ `${item.discount_percentage}%` }}</span>
    </template>
    <template v-slot:item.product_name="{ item }">
        <span>{{ productName(item.product_name) }}</span>
    </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataTableCountryHolidays',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        { text: 'Date', value: 'holiday_date' },
        { text: 'Discount percentage', value: 'discount_percentage' },
        { text: 'Product', value: 'product_name' }
      ],
      mobileBreakpoint: 767 // screen width in pixel to switch to mobile view
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    productName(name) {
      return 'Visitor parking'
    }
  }
}
</script>
<style lang="scss" scoped>
.reports__data .theme--light:focus:before {
  opacity: 1 !important;
}

::v-deep .tooltip-column {
  max-width: 145px;
}
::v-deep .ellipsed-text {
  width: 100%;
  display: block;
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}

::v-deep th {
  text-wrap: nowrap;
}
</style>
